var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.alert)?_c('AlertMessage',{attrs:{"type":_vm.alert.type,"message":_vm.alert.message}}):_vm._e(),_c('router-view',{on:{"submit-form":_vm.submitForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }